import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonMaterialModule } from '@nrwl/common-material';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild, OnInit, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Device, DevicesService } from '@nrwl/common-lib';

@Component({
  selector: 'nrwl-frame-size-selector',
  standalone: true,
  imports: [CommonModule, CommonMaterialModule, FormsModule, ReactiveFormsModule],
  templateUrl: './frame-size-selector.component.html',
  styleUrls: ['./frame-size-selector.component.scss']
})
export class FrameSizeSelectorComponent implements OnInit {
  @ViewChild('sctFrameSizeInput') sctFrameSizeInput: ElementRef<HTMLInputElement>;
  @ViewChild('sptFrameSizeInput') sptFrameSizeInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  sctFrameSizeCtrl = new FormControl('');
  filteredSctFrames: Observable<string[]>;
  selectedSctEmixFrames: string[] = ['512', '1518'];
  sctEmixFramesList: string[];

  sptFrameSizeCtrl = new FormControl('');
  filteredSptFrames: Observable<string[]>;
  selectedSptEmixFrames: string[] = ['512', '1518'];
  sptEmixFramesList: string[];

  isMultiSelectFrameEnabled = false;
  isToggle = false;
  minMaxSptFramesMsg = false;
  minMaxSctFramesMsg = false;
  sctEmixList: string[];
  sptEmixList: string[];
  selectedSctFramesList: any[];
  selectedSptFramesList: any[];
  selectedVlans: number;
  sctSptcustomFrames: string[];

  sctVlanAdjustedFramesList: any[] = [];
  sptVlanAdjustedFramesList: any[] = [];
  sctCustomFrame: any;
  sptCustomFrame: any;
  minValue: number;
  maxValue: number;
  disabledIcon = 'sct-frame-selector mdi mdi-plus-thick';
  enabledIcon = 'sct-frame-selector check-icon mdi mdi-check-bold';

  constructor(
    public dialogRef: MatDialogRef<FrameSizeSelectorComponent>,
    private deviceService: DevicesService,
    @Inject(MAT_DIALOG_DATA) public data: object
  ) {
    if (data) {
      this.selectedSctFramesList = data['sctFrames'];
      this.selectedSptFramesList = data['sptFrames'];
      this.selectedVlans = data['rowData']?.['selectedVlans'];
      this.sptEmixFramesList = this.getEmixFrames();
      this.isMultiSelectFrameEnabled = data?.['isMultiSelectEnable'];
      this.minValue = data['rowData']?.['minValue'];
      this.maxValue = data['rowData']?.['maxValue'];
    }
    this.filteredSctFrames = this.sctFrameSizeCtrl.valueChanges.pipe(
      startWith(null),
      map((frame: string | null) =>
        frame ? this._filterSctEmixFrames(frame) : this.sctEmixFramesList.slice()
      )
    );
    this.filteredSptFrames = this.sptFrameSizeCtrl.valueChanges.pipe(
      startWith(null),
      map((frame: string | null) =>
        frame ? this._filterSptEmixFrames(frame) : this.sptEmixFramesList.slice()
      )
    );
  }

  ngOnInit(): void {
    this.selectedSctFramesList?.forEach(item => {
      if (item['label'] === 'custom') {
        this.sctCustomFrame = item['value'];
      } else if (item['label'] === 'EMIX') {
        this.sctEmixList = item['value'];
      }
    });
    this.selectedSptFramesList?.forEach(item => {
      if (item['label'] === 'custom') {
        this.sptCustomFrame = item['value'];
      } else if (item['label'] === 'EMIX') {
        this.sptEmixList = item['value'];
      }
    });
    this.selectedSctEmixFrames = this.sctEmixList;
    this.selectedSptEmixFrames = this.sptEmixList;
    this.sctVlanAdjustedFrames();
    this.sptVlanAdjustedFrames();
  }

  getEmixFrames(): any {
    const emixFramesList = [];
    this.selectedSptFramesList?.forEach(item => {
      if (item['label'] !== 'custom' && item['label'] !== 'EMIX') {
        emixFramesList.push(item['label']);
      }
    });
    return emixFramesList;
  }
  sctVlanAdjustedFrames(): void {
    this.sctVlanAdjustedFramesList = [];
    this.selectedSctFramesList?.forEach(item => {
      if (this.selectedVlans !== 0) {
        if (item['label'] === 'custom') {
          this.sctVlanAdjustedFramesList.push(
            parseInt(this.sctCustomFrame) + 4 * this.selectedVlans
          );
        } else if (item['label'] === 'EMIX') {
          const emixFrames = [];
          this.selectedSctEmixFrames.forEach(item => {
            emixFrames.push(parseInt(item) + 4 * this.selectedVlans);
          });
          this.sctVlanAdjustedFramesList.push(emixFrames.join());
        } else {
          this.sctVlanAdjustedFramesList.push(item['value'] + 4 * this.selectedVlans);
        }
      } else {
        this.sctVlanAdjustedFramesList.push(item['value'] + 4 * this.selectedVlans);
      }
    });
  }
  sptVlanAdjustedFrames(): void {
    this.sptVlanAdjustedFramesList = [];
    this.selectedSptFramesList?.forEach(item => {
      if (this.selectedVlans !== 0) {
        if (item['label'] === 'custom') {
          this.sptVlanAdjustedFramesList.push(
            parseInt(this.sptCustomFrame) + 4 * this.selectedVlans
          );
        } else if (item['label'] === 'EMIX') {
          const emixFrames = [];
          this.selectedSptEmixFrames.forEach(item => {
            emixFrames.push(parseInt(item) + 4 * this.selectedVlans);
          });
          this.sptVlanAdjustedFramesList.push(emixFrames.join());
        } else {
          this.sptVlanAdjustedFramesList.push(item['value'] + 4 * this.selectedVlans);
        }
      } else {
        this.sptVlanAdjustedFramesList.push(item['value'] + 4 * this.selectedVlans);
      }
    });
  }
  addSctEmixFrames(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      if (
        this.selectedSctEmixFrames?.length < 8 &&
        parseInt(value) >= this.minValue &&
        parseInt(value) <= this.maxValue
      ) {
        this.minMaxSctFramesMsg = false;
        this.selectedSctEmixFrames.push(value);
      } else {
        this.minMaxSctFramesMsg = true;
      }
    }
    event.chipInput!.clear();
    this.sctFrameSizeCtrl.setValue(null);
    this.sctVlanAdjustedFrames();
  }
  removeSctEmixFrame(frame: string): void {
    const index = this.selectedSctEmixFrames.indexOf(frame);
    if (index >= 0) {
      this.selectedSctEmixFrames.splice(index, 1);
      if (this.selectedSctEmixFrames?.length < 2 || this.selectedSctEmixFrames?.length >= 8) {
        this.minMaxSctFramesMsg = false;
      }
    }
    this.sctVlanAdjustedFrames();
  }
  selectSctEmixFrame(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedSctEmixFrames?.length < 8) {
      this.selectedSctEmixFrames.push(event.option.viewValue);
      this.minMaxSctFramesMsg = false;
    }
    this.sctVlanAdjustedFrames();
    this.sctFrameSizeInput.nativeElement.value = '';
    this.sctFrameSizeCtrl.setValue(null);
  }
  addSptEmixFrames(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      if (
        this.selectedSptEmixFrames?.length < 8 &&
        parseInt(value) >= this.minValue &&
        parseInt(value) <= this.maxValue
      ) {
        this.minMaxSptFramesMsg = false;
        this.selectedSptEmixFrames.push(value);
      } else {
        this.minMaxSptFramesMsg = true;
      }
    }
    event.chipInput!.clear();
    this.sptFrameSizeCtrl.setValue(null);
    this.sptVlanAdjustedFrames();
  }
  removeSptEmixFrame(frame: string): void {
    const index = this.selectedSptEmixFrames.indexOf(frame);
    if (index >= 0) {
      this.selectedSptEmixFrames.splice(index, 1);
      if (this.selectedSptEmixFrames?.length < 2 || this.selectedSptEmixFrames?.length >= 8) {
        this.minMaxSptFramesMsg = false;
      }
    }
    this.sptVlanAdjustedFrames();
  }
  selectSptEmixFrame(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedSptEmixFrames?.length < 8) {
      this.selectedSptEmixFrames.push(event.option.viewValue);
      this.minMaxSptFramesMsg = false;
    }
    this.sptFrameSizeInput.nativeElement.value = '';
    this.sptFrameSizeCtrl.setValue(null);
    this.sptVlanAdjustedFrames();
  }
  onSelectSctFrame(enable: boolean, index: number): void {
    this.selectedSctFramesList[index]['enable'] = !enable;
  }
  onSelectSptFrame(enable: boolean, index: number): void {
    if (!this.data['multiSelectFramesEnabled']) {
      this.selectedSptFramesList.forEach(item => {
        item['enable'] = false;
      });
    }
    this.selectedSptFramesList[index]['enable'] = !enable;
  }
  onselectToggleAll(): void {
    this.isToggle = !this.isToggle;
    this.selectedSctFramesList?.forEach(item => {
      if (this.isToggle) {
        item['enable'] = this.isToggle;
      } else if (item['value'] !== 512) {
        item['enable'] = this.isToggle;
      }
    });
  }
  onConfigToggleChange(): void {
    this.sctVlanAdjustedFrames();
  }
  isValidFrameSelection(): boolean {
    if (
      this.selectedSctEmixFrames?.length < 2 ||
      this.selectedSptEmixFrames?.length < 2 ||
      this.sctCustomFrame < this.minValue ||
      this.sctCustomFrame > this.maxValue ||
      this.sptCustomFrame < this.minValue ||
      this.sptCustomFrame > this.maxValue
    ) {
      return true;
    } else {
      return false;
    }
  }
  getSelectedSctFrames(): string[] {
    let selectedSctFrames;
    if (this.isMultiSelectFrameEnabled) {
      selectedSctFrames = this.selectedSctFramesList
        .filter(item => item['enable'] && item['label'] !== 'custom' && item['label'] !== 'EMIX')
        .map(item => item['value']);
      selectedSctFrames.push(
        this.selectedSctFramesList
          .filter(item => item['enable'] && item['label'] === 'custom')
          .map(item => [item['label'] + ':' + this.sctCustomFrame.toString().replaceAll(',', ':')])
      );
      selectedSctFrames.push(
        this.selectedSctFramesList
          .filter(item => item['enable'] && item['label'] === 'EMIX')
          .map(item => [item['label'] + ':' + item['value'].toString().replaceAll(',', ':')])
      );

      return selectedSctFrames.toString().replaceAll(',,', ',');
    } else {
      return null;
    }
  }
  getSelectedSptFrames(): string[] {
    let selectedSptFrames;
    // eslint-disable-next-line prefer-const
    selectedSptFrames = this.selectedSptFramesList
      .filter(item => item['enable'] && item['label'] !== 'custom' && item['label'] !== 'EMIX')
      .map(item => item['value']);
    selectedSptFrames.push(
      this.selectedSptFramesList
        .filter(item => item['enable'] && item['label'] === 'custom')
        .map(item => [item['label'] + ':' + this.sptCustomFrame.toString().replaceAll(',', ':')])
    );
    selectedSptFrames.push(
      this.selectedSptFramesList
        .filter(item => item['enable'] && item['label'] === 'EMIX')
        .map(item => [item['label'] + ':' + item['value'].toString().replaceAll(',', ':')])
    );
    if (this.data['multiSelectFramesEnabled']) {
      return selectedSptFrames.toString().replaceAll(',,', ',');
    } else {
      return selectedSptFrames.toString().replaceAll(',', '');
    }
  }
  saveFrameSelection(): void {
    this.dialogRef.close({
      sctFrames: this.getSelectedSctFrames(),
      sptFrames: this.getSelectedSptFrames(),
      sctEmix: this.selectedSctEmixFrames,
      sptEmix: this.selectedSptEmixFrames,
      sctCustomFrame: this.sctCustomFrame,
      sptCustomFrame: this.sptCustomFrame,
      isMultiSelectEnable: this.isMultiSelectFrameEnabled
    });
  }
  SelectSctCustomFrame(): void {
    this.sctVlanAdjustedFrames();
  }
  SelectSptCustomFrame(): void {
    this.sptVlanAdjustedFrames();
  }

  private _filterSctEmixFrames(value: string): string[] {
    const filterValue = value?.toString()?.toLowerCase();
    return this.sctEmixFramesList.filter(frame =>
      frame?.toString()?.toLowerCase().includes(filterValue)
    );
  }
  private _filterSptEmixFrames(value: string): string[] {
    const filterValue = value?.toString()?.toLowerCase();
    return this.sptEmixFramesList.filter(frame =>
      frame?.toString()?.toLowerCase().includes(filterValue)
    );
  }
}
